import React from "react";
import "../Styles/404.css";

const Page404 = () => {
  return (
    <div className='divContainer404'>
      <h1>Awww...Don't Cry.</h1>
      <h3>it's just a 404 error!</h3>
      <h3>You just hit a route that doesn&#39;t exist... the sadness.</h3>
      <div className='div404' />
    </div>
  );
};

export default Page404;
